import React from 'react';
import { Link } from 'react-router-dom';
import LanguageSwitcher from './LanguageSwitcher';

const TermsOfUsePage = ({ language, setLanguage, t, app }) => {
  console.log('TermsOfUsePage props', { t, app, language });
  const terms = app === 'quitsnus' ? t?.quitSnusTerms : t?.mrPiggyTerms;

  if (!terms || !t) {
    console.error(`Terms not found for app: ${app}`, { t, language });
    return (
      <div className="container">
        <LanguageSwitcher language={language} setLanguage={setLanguage} />
        <Link
          to={app === 'quitsnus' ? '/quitsnus' : app === 'mrpiggy' ? '/mrpiggy' : '/'}
          className="back-button"
        >
          <svg
            style={{ width: '1rem', height: '1rem' }}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M15 19l-7-7 7-7"
            />
          </svg>
          {t?.back || 'Back'}
        </Link>
        <section className="app-header">
          <h1>Error</h1>
          <p>Terms of use not found. Please try again later.</p>
        </section>
      </div>
    );
  }

  return (
    <div className="container">
      <LanguageSwitcher language={language} setLanguage={setLanguage} />
      <Link
        to={app === 'quitsnus' ? '/quitsnus' : app === 'mrpiggy' ? '/mrpiggy' : '/'}
        className="back-button"
      >
        <svg
          style={{ width: '1rem', height: '1rem' }}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M15 19l-7-7 7-7"
          />
        </svg>
        {t.back || 'Back'}
      </Link>
      <section className="app-header">
        <h1>{terms.title}</h1>
        <p>{terms.lastUpdated}</p>
      </section>
      <div className="description">
        {Object.entries(terms.sections || {}).map(([key, section]) => (
          <div key={key} style={{ marginBottom: '1.5rem' }}>
            <h2>{section.title}</h2>
            <p>{section.content}</p>
          </div>
        ))}
      </div>
      <footer className="links">
        <Link to="/">{t.ourApps || 'Home'}</Link>
        <Link to="/quitsnus">{t.quitSnusTitle || 'QuitSnus'}</Link>
        <Link to="/mrpiggy">{t.mrPiggyTitle || 'Mr Piggy'}</Link>
        <Link to="/quitsnus-privacy">{t.privacyPolicy || 'QuitSnus Privacy'}</Link>
        <Link to="/quitsnus-terms">{t.termsOfUse || 'QuitSnus Terms'}</Link>
        <Link to="/mrpiggy-privacy">{t.privacyPolicy || 'Mr Piggy Privacy'}</Link>
        <Link to="/mrpiggy-terms">{t.termsOfUse || 'Mr Piggy Terms'}</Link>
      </footer>
    </div>
  );
};

export default TermsOfUsePage;